import { ModuleWithProviders, NgModule } from "@angular/core";
import { UiKitDatepickerDirective } from "./datepicker.directive";
import { DatepickerDefaults, DatepickerDefaultsInterface } from "./defaults.service";
import { USER_DEFAULTS } from "./tokens";

export function defaultsFactory(userDefaults: DatepickerDefaultsInterface): DatepickerDefaults {
    const defaults: DatepickerDefaults = new DatepickerDefaults();
    return { ...defaults, ...userDefaults } as DatepickerDefaults;
}

@NgModule({
    imports: [UiKitDatepickerDirective],
    exports: [UiKitDatepickerDirective]
})
export class UiKitDatepickerModule {
    static forRoot(userDefaults: DatepickerDefaultsInterface = {}): ModuleWithProviders<UiKitDatepickerModule> {
        return {
            ngModule: UiKitDatepickerModule,
            providers: [
                {
                    provide: USER_DEFAULTS,
                    useValue: userDefaults
                },
                {
                    provide: DatepickerDefaults,
                    useFactory: defaultsFactory,
                    deps: [USER_DEFAULTS]
                }
            ]
        };
    }
}
